
const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "Name",
                "tableName": "VectorStore",
                "label": "Name",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "Description",
                "tableName": "VectorStore",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
];

const PrimaryLayout = () => [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "Name",
                "tableName": "VectorStore",
                "label": "Name",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
                "MaxLength": 100,
            },
            {
                "name": "CreatedAt",
                "tableName": "VectorStore",
                "label": "Created At (Unix timestamp)",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "FilesInProgress",
                "tableName": "VectorStore",
                "label": "Files In Progress",
                "type": "number",
                "format": "#,##0",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "Description",
                "tableName": "VectorStore",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "MaxLength": 500,
            },
            {
                "name": "FilesCancelled",
                "tableName": "VectorStore",
                "label": "Files Cancelled",
                "type": "number",
                "format": "#,##0",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "FilesTotal",
                "tableName": "VectorStore",
                "label": "Files Total",
                "type": "number",
                "format": "#,##0",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "ExpiresAfterDays",
                "tableName": "VectorStore",
                "label": "Expires After (Days)",
                "type": "number",
                "format": "#,##0",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "FilesCompleted",
                "tableName": "VectorStore",
                "label": "Files Completed",
                "type": "number",
                "format": "#,##0",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "UsageBytes",
                "tableName": "VectorStore",
                "label": "Usage Bytes",
                "type": "number",
                "format": "#,##0",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "Status",
                "tableName": "VectorStore",
                "label": "Status",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "FilesFailed",
                "tableName": "VectorStore",
                "label": "Files Failed",
                "type": "number",
                "format": "#,##0",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "ExpiresAt",
                "tableName": "VectorStore",
                "label": "Expires At (Unix timestamp)",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": true,
            }
        ]
    }
]

export {
    SearchLayout,
    PrimaryLayout
}